import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { getBlogs } from '../../provider/Blogs';
import { getArray, getArrayLength } from '../../utils/helpers';
import { languageStore } from '../../subscriber/Language';
import HeroSection from '../../components/HeroSection';
import SeoHelmet from '../../components/SeoHelmet';
import BlogPost from '../../components/BlogPost';
import staticBlogs from '../../data/blogs.json';
import pages from '../../subscriber/Pages';
import Layout from "../layout";
// Import images
import busyChefsImage from '../../assets/chef_luca_blog_image.png';
// import marbleTexture from '../../assets/light-grey-marble-texture-background-luxury-look-table-top-.jpg';

const Blog = observer(() => {
    const [hydrated, setHydrated] = useState(false);
    // const [subscribed, setSubscribed] = useState(false);
    // const [email, setEmail] = useState('');
    
    const { blogs } = pages || {}
    
    useEffect(() => {
        setHydrated(true);
        if (getArrayLength(blogs) === 0) {
            getBlogs();
        }
    }, [blogs]);

    const { getPageTranslations } = languageStore;
    const t = getPageTranslations('blog');
    
    // const handleSubscribe = (e) => {
    //     e.preventDefault();
    //     // Add your subscription logic here
    //     setSubscribed(true);
    // };
    
    // 👇 SEO meta only from Home
    const seoBlogs = staticBlogs.find(b => b.slug === 'blogs');

    const renderMain = () => {
        if (!hydrated || getArrayLength(blogs) === 0) return null;
        
        const latest_blogs = getArray(blogs).slice(0, 2);
        const other_blogs = getArray(blogs).slice(2)

        return (
            <div className="bg-[#FFEDE1]">
                {/* Hero Section */}
                <HeroSection 
                    backgroundImage={busyChefsImage}
                    title={t.blogArticle}
                />

                {/* Blog Posts Section */}
                <section className="py-24 bg-[#FFF]">
                    <div className="container mx-auto">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                            {getArray(latest_blogs).map(post => (
                                <BlogPost key={post.id} blog={post} t={t} />
                            ))}
                        </div>
                    </div>
                </section>

                {/* Newsletter Section */}
                {/* <s ection className="py-24 relative" style={{ backgroundColor: '#FFEDE1' }}>
                    <div className="absolute inset-0 z-0">
                        <img
                            src={marbleTexture}
                            alt="Marble Texture"
                            layout="fill"
                            objectFit="cover"
                            className="opacity-10 mix-blend-luminosity"
                        />
                    </div>
                    <div className="container mx-auto relative z-10">
                        <div className="flex flex-col md:flex-row items-center">
                            <div className="md:w-1/2 mb-8 md:mb-0 md:pr-8">
                                <h2 className="font-['Libre_Caslon_Display'] text-[40px] leading-[1.2em] tracking-[-0.015em] text-[#1F0707] mb-4">
                                    {t.getLatestInsights}
                                </h2>
                            </div>
                            <div className="md:w-1/2">
                                <form onSubmit={handleSubscribe} className="flex flex-col md:flex-row">
                                    <input
                                        type="email"
                                        placeholder={t.yourEmail}
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        className="flex-grow p-4 border border-[#5E0E0E63] bg-transparent text-[#1F0707] placeholder-[#1F070757] mb-4 md:mb-0 md:mr-4"
                                        required
                                    />
                                    <button
                                        type="submit"
                                        className="bg-[#D3752B] text-white uppercase py-4 px-8 border border-[#D3752B] hover:bg-transparent hover:text-[#D3752B] transition-colors duration-300"
                                    >
                                        {t.subscribe}
                                    </button>
                                </form>
                                {subscribed && <p className="mt-4 text-green-600">{t.successMessage}</p>}
                            </div>
                        </div>
                    </div>
                </section> */}
                {/* Blog Posts Section */}
                
                {/* More Blog Posts Section */}
                <section className="py-24 bg-[#FFF]">
                    <div className="container mx-auto">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                            {getArray(other_blogs).map(post => (
                                <BlogPost key={post.id} blog={post} t={t} />
                            ))}
                        </div>
                    </div>
                </section>
            </div>
        );
    }

    return (
        <Layout>
            <SeoHelmet
                title={seoBlogs.name}
                description={seoBlogs.sort_description}
                image={seoBlogs.path}
                url={seoBlogs.url}
            />
            {renderMain()}
        </Layout>
    );
});

export default Blog;
